import { RewardsTranslationNamespaces } from "@apps/rewards/constants/constants";
import RewardsDiResolverService from "@apps/rewards/services/RewardsDiResolverService/RewardsDIResolverService";
import RewardsStorefrontValuesService from "@apps/rewards/services/RewardsStorefrontValuesService";
import { AuthenticationModule } from "@modules/authentication/AuthenticationModule";
import { CommonModule } from "@modules/common_module/CommonModule";
import { I18nModule } from "@modules/i18n/I18nModule";
import { injectable } from "tsyringe";

import type { LoggerInterface } from "@interfaces/LoggerInterface";
import type { WidgetInterface } from "@interfaces/WidgetInterface";

import RewardsEmptyStatePageWidgetComponent from "./RewardsEmptyStatePageWidget.svelte";
import type { RewardsEmptyStatePageWidgetConfig } from "./RewardsEmptyStatePageWidgetConfigSchema";

@injectable()
class RewardsEmptyStatePageWidget implements WidgetInterface {
    constructor(
        private readonly config: RewardsEmptyStatePageWidgetConfig,
        private readonly logger: LoggerInterface
    ) {
        this.logger.debug("RewardsEmptyStatePageWidget is initialized");
    }

    init(): this {
        const widgetNamespace =
            RewardsTranslationNamespaces.rewardsEmptyStatePageWidget;

        const diResolverService = new RewardsDiResolverService();
        const {
            i18nModule,
            rewardsStorefrontValuesService,
            commonModule,
            authenticationModule,
        } = diResolverService.resolveAll({
            i18nModule: I18nModule,
            rewardsStorefrontValuesService: RewardsStorefrontValuesService,
            commonModule: CommonModule,
            authenticationModule: AuthenticationModule,
        });

        const { i18n, i18nApiLoaderFactory } = i18nModule.exports;
        i18n.registerLoader(
            widgetNamespace,
            i18nApiLoaderFactory.getLoader(widgetNamespace)
        );

        const { locationController, urlsBuilder } = commonModule.exports;

        const placeholder = document.createElement("div");
        placeholder.classList.add("gw-rd-empty-state-page-widget-placeholder");
        placeholder.style.display = "block";
        this.config.target.appendChild(placeholder);

        const shadowRoot =
            placeholder.shadowRoot ||
            placeholder.attachShadow({ mode: "open" });

        new RewardsEmptyStatePageWidgetComponent({
            target: shadowRoot,
            props: {
                rewardsStorefrontValuesService,
                authenticationInfoProvider:
                    authenticationModule.exports.authenticationInfoProvider,
                locationController,
                urlsBuilder,
                namespace: widgetNamespace,
            },
        });

        return this;
    }
}

export default RewardsEmptyStatePageWidget;
